import { render, staticRenderFns } from "./management_style.vue?vue&type=template&id=73cebd94&scoped=true&"
import script from "./management_style.vue?vue&type=script&lang=js&"
export * from "./management_style.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cebd94",
  null
  
)

export default component.exports